import { Component, Input, OnInit } from '@angular/core';
import { ClientPrescriberTask } from '../../../core/models/client-prescriber-task.model';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-client-prescriber-task-visibility',
    templateUrl: './client-prescriber-task-visibility.component.html',
    styleUrls: ['./client-prescriber-task-visibility.component.scss'],
    imports: [NgClass]
})
export class ClientPrescriberTaskVisibilityComponent implements OnInit {
  @Input() task: ClientPrescriberTask;

  cssClasses = '';

  constructor() {}

  ngOnInit() {
    if (this.task.clientVisible) {
      this.cssClasses = 'alert alert-warning p-1';
    } else {
      this.cssClasses = 'alert alert-light p-1 bg-transparent';
    }
  }
}
